import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import FieldNames from "../defaults/FieldNames.json";
import GeneralService from "./GeneralService";
import { getAppConfig, getAttributeServiceUrl } from "../utils/ReduxHelper";

const UserHelperService = {
  getUnitEntryByAllFields: async function(department, agency, region, unit, subUnit, tribe){
    const config = getAppConfig();
    const rootServiceUrl = getAttributeServiceUrl();
    const checkedDepartment = department && department.includes("'") ? department.replaceAll("'", "''") : (department ? department : "");
    const checkedAgency = agency && agency.includes("'") ? agency.replaceAll("'", "''") : (agency ? agency : "");
    const checkedRegion = region && region.includes("'") ? region.replaceAll("'", "''") : (region ? region : "");
    const checkedUnit = unit && unit.includes("'") ? unit.replaceAll("'", "''") : (unit ? unit : "");
    const checkedSubUnit = subUnit && subUnit.includes("'") ? subUnit.replaceAll("'", "''") : (subUnit ? subUnit : "");
    const checkedTribe = tribe && tribe.includes("'") ? tribe.replaceAll("'", "''") : (tribe ? tribe : "");
    let queryObject = new Query({
      where: `((Department = '${checkedDepartment}') AND (Agency = '${checkedAgency}') AND (Region = '${checkedRegion}') AND (Unit = '${checkedUnit}'))`,
      outFields: "*",
      returnDistinctValues: true,
      returnGeometry: false,
    });
    if(checkedAgency && checkedAgency.includes(FieldNames.agencies.blm)){
      if(checkedSubUnit?.length > 0){
        queryObject = new Query({
          where: `((Department = '${checkedDepartment}') AND (Agency = '${checkedAgency}') AND (Region = '${checkedRegion}') AND (Unit = '${checkedUnit}') AND (SubUnit = '${checkedSubUnit}'))`,
          outFields: "*",
          returnDistinctValues: true,
          returnGeometry: false,
        });
      } 
    } else if(checkedAgency && checkedAgency.includes(FieldNames.agencies.bia)){
      if(checkedRegion && checkedUnit && checkedTribe){
        queryObject = new Query({
          where: `((Department = '${checkedDepartment}') AND (Agency = '${checkedAgency}') AND (Region = '${checkedRegion}') AND (Unit = '${checkedUnit}') AND (TribeFullName = '${checkedTribe}'))`,
          outFields: "*",
          returnDistinctValues: true,
          returnGeometry: false,
        });
      } else if(checkedTribe && checkedRegion && !checkedUnit){
        queryObject = new Query({
          where: `((Department = '${checkedDepartment}') AND (Agency = '${checkedAgency}') AND (Region = '${checkedRegion}') AND (TribeFullName = '${checkedTribe}'))`,
          outFields: "*",
          returnDistinctValues: true,
          returnGeometry: false,
        });
      } else if(checkedTribe && !checkedUnit && !checkedRegion){
        queryObject = new Query({
          where: `((Department = '${checkedDepartment}') AND (Agency = '${checkedAgency}') AND (TribeFullName = '${checkedTribe}'))`,
          outFields: "*",
          returnDistinctValues: true,
          returnGeometry: false,
        });
      }
      
    } 
    if((checkedDepartment && checkedAgency && checkedRegion && checkedUnit) || (checkedAgency && checkedAgency.includes(FieldNames.agencies.bia))){
      return await GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results?.features && results?.features?.length > 0) {
          items = results?.features?.map((eaItem) => eaItem.attributes);
          if(checkedAgency?.includes(FieldNames.agencies.bia) && !checkedTribe){
            items = items?.filter(x => x[FieldNames.units.tribeFullName] === '')
          }
          if(checkedAgency?.includes(FieldNames.agencies.blm) && !checkedSubUnit){
            items = items?.filter(x => x[FieldNames.units.subUnit] === '');
          }
        } 
        return(items)
      }).catch(error => {
        return new Promise((resolve,reject) => {
          reject(error);
        });
      });   
    } else {
      return new Promise((resolve,reject) => {
        resolve([]);
      });
    }
  },
  getAllUnitTableCombinations: function(outFields="Department, Agency, Region, Unit, SubUnit, TribeFullName") {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();

      const queryObject = new Query({
        where: "1=1",
        outFields: outFields,
        returnDistinctValues: true,
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return (items)
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllDepartments: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "Department",
        returnDistinctValues: true,
        orderByFields: "Department",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllFundingUnitTypes: function(){
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "UnitType",
        returnDistinctValues: true,
        orderByFields: "UnitType",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllAgencies: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "Agency",
        returnDistinctValues: true,
        orderByFields: "Agency",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllRegions: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "Region",
        returnDistinctValues: true,
        orderByFields: "Region",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllUnits: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "Unit",
        returnDistinctValues: true,
        orderByFields: "Unit",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllSubUnits: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "SubUnit",
        returnDistinctValues: true,
        orderByFields: "SubUnit",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return (items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllUnitTypes: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "UnitType",
        returnDistinctValues: true,
        orderByFields: "UnitType",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllTribes: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "TribeFullName",
        returnDistinctValues: true,
        orderByFields: "TribeFullName",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAllLocationAgencies: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "Agency",
        returnDistinctValues: true,
        orderByFields: "Agency",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAgencyByDepartment: function(department) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const checkedDepartment = department.includes("'") ? department.replaceAll("'", "''") : department;

      const queryObject = new Query({
        where: `(Department = '${checkedDepartment}')`,
        outFields: "Agency",
        returnDistinctValues: true,
        orderByFields: "Agency",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getAgencyByDepartments: function(departments) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      departments.forEach((dept) => {
        const checkedDepartment = dept.includes("'") ? dept.replaceAll("'", "''") : dept;
        whereArray.push("(Department = '" + checkedDepartment + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "Agency",
        returnDistinctValues: true,
        orderByFields: "Agency",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getRegionsByAgency: function(agency) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const checkedAgency = agency.includes("'") ? agency.replaceAll("'", "''") : agency;

      const queryObject = new Query({
        where: `(Agency = '${checkedAgency}')`,
        outFields: "Region",
        returnDistinctValues: true,
        orderByFields: "Region",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getRegionsByAgencies: function(agencies) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      agencies.forEach((agency) => {
        const checkedAgency = agency.includes("'") ? agency.replaceAll("'", "''") : agency;
        whereArray.push("(Agency = '" + checkedAgency + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "Region",
        returnDistinctValues: true,
        orderByFields: "Region",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getUnitsByRegions: function(regions) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      regions.forEach((reg) => {
        const checkedRegion = reg.includes("'") ? reg.replaceAll("'", "''") : reg;
        whereArray.push("(Region = '" + checkedRegion + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "Unit",
        returnDistinctValues: true,
        orderByFields: "Unit",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getUnitsByAgency: function(agency) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const checkedAgency = agency.includes("'") ? agency.replaceAll("'", "''") : agency;

      const queryObject = new Query({
        where: `(Agency = '${checkedAgency}')`,
        outFields: "Unit",
        returnDistinctValues: true,
        orderByFields: "Unit",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getBiaUnits: function() {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = config.tribeLeaders.url
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "biaagency",
        returnDistinctValues: true,
        orderByFields: "biaagency",
        returnGeometry: false,
      });
      return query.executeQueryJSON(rootServiceUrl, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getBlmFieldUnits: function() {
    try
    {
      const config = getAppConfig();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "ADMU_NAME",
        returnDistinctValues: true,
        orderByFields: "ADMU_NAME",
        returnGeometry: false,
      });
      return query.executeQueryJSON(config.BLMField.url, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getBlmOtherUnits: function() {
    try
    {
      const config = getAppConfig();
      const queryObject = new Query({
        where: `(OBJECTID IS NOT NULL)`,
        outFields: "ADMU_NAME",
        returnDistinctValues: true,
        orderByFields: "ADMU_NAME",
        returnGeometry: false,
      });
      return query.executeQueryJSON(config.BLMOther.url, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getUnitsByRegionsAgency: function(regions, agency) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const checkedAgency = agency.includes("'") ? agency.replaceAll("'", "''") : agency;

      let whereArray = [];
      regions.forEach((reg) => {
        const checkedRegion = reg.includes("'") ? reg.replaceAll("'", "''") : reg;
        whereArray.push("(Region = '" + checkedRegion + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: `((Agency = '${checkedAgency}') AND (${whereClause}))`,
        outFields: "Unit",
        returnDistinctValues: true,
        orderByFields: "Unit",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getUnitsByRegionsAgencies: function(regions, agencies) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      let agencyWhereArray = [];
      regions.forEach((reg) => {
        const checkedRegion = reg.includes("'") ? reg.replaceAll("'", "''") : reg;
        whereArray.push("(Region = '" + checkedRegion + "')");
      })
      agencies.forEach((agency) => {
        const checkedAgency = agency.includes("'") ? agency.replaceAll("'", "''") : agency;
        agencyWhereArray.push("(Agency = '" + checkedAgency + "')");
      })
      const whereClause = whereArray.length > 0 ? "(" + whereArray.join(" OR ") + ")" : "";
      const agencyWhereClause = agencyWhereArray.length > 0 ? "(" + agencyWhereArray.join(" OR ") + ")" : "";
      const joinOperator = (whereArray.length > 0 && agencyWhereArray.length > 0) ? " AND " : "";

      const queryObject = new Query({
        where: `(${agencyWhereClause}${joinOperator}${whereClause})`,
        outFields: "Unit",
        returnDistinctValues: true,
        orderByFields: "Unit",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getTribesByRegions: function(regions) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      regions.forEach((reg) => {
        const checkedRegion = reg.includes("'") ? reg.replaceAll("'", "''") : reg;
        whereArray.push("(Region = '" + checkedRegion + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "TribeFullName",
        returnDistinctValues: true,
        orderByFields: "TribeFullName",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getSubUnitsByUnits: function(units) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      units.forEach((unit) => {
        const checkedUnit = unit.includes("'") ? unit.replaceAll("'", "''") : unit;
        whereArray.push("(Unit = '" + checkedUnit + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "SubUnit",
        returnDistinctValues: true,
        orderByFields: "SubUnit",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getTribesByUnits: function(units) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      units.forEach((unit) => {
        const checkedUnit = unit.includes("'") ? unit.replaceAll("'", "''") : unit;
        whereArray.push("(Unit = '" + checkedUnit + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "TribeFullName",
        returnDistinctValues: true,
        orderByFields: "TribeFullName",
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getSubUnitsWithUnitsBySubUnits: function(subUnits){
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      subUnits.forEach((subUnit) => {  
        const checkedSubUnit = subUnit.includes("'") ? subUnit.replaceAll("'", "''") : subUnit;
        whereArray.push("(SubUnit = '" + checkedSubUnit + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "Unit",
        returnDistinctValues: true,
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });
        }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getUnitsWithRegionsByUnits: function(units) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      units.forEach((unit) => {
        const checkedUnit = unit.includes("'") ? unit.replaceAll("'", "''") : unit;
        whereArray.push("(Unit = '" + checkedUnit + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "Region",
        returnDistinctValues: true,
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getRolesByAgenciesRegions: function(agencies, regions) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      let whereAgencyArray = [];
      regions.forEach((reg) => {
        const checkedRegion = reg.includes("'") ? reg.replaceAll("'", "''") : reg;
        whereArray.push("(Region = '" + checkedRegion + "')");
      })
      agencies.forEach((agency) => {
        const checkedAgency = agency.includes("'") ? agency.replaceAll("'", "''") : agency;
        whereAgencyArray.push("(Agency = '" + checkedAgency + "')");
      })
      const whereClause = whereArray.join(" OR ");
      const whereAgencyClause = whereAgencyArray.join(" OR ");
      const finalWhereClause = "((" + whereClause + ") AND (" + whereAgencyClause + "))";

      const queryObject = new Query({
        where: finalWhereClause,
        outFields: "Department, Agency, Region, Unit, SubUnit, UnitType, TribeFullName",
        returnDistinctValues: true,
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getSubUnitsForUnitsByUnits: function(units) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      units.forEach((unit) => {
        const checkedUnit = unit.includes("'") ? unit.replaceAll("'", "''") : unit;
        whereArray.push("(Unit = '" + checkedUnit + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "Department, Agency, Region, Unit, SubUnit, UnitType, TribeFullName",
        returnDistinctValues: true,
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return(items)
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getTribesForUnitsByUnits: function(units) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      let whereArray = [];
      units.forEach((unit) => {
        const checkedUnit = unit.includes("'") ? unit.replaceAll("'", "''") : unit;
        whereArray.push("(Unit = '" + checkedUnit + "')");
      })
      const whereClause = "(" + whereArray.join(" OR ") + ")";

      const queryObject = new Query({
        where: whereClause,
        outFields: "Department, Agency, Region, Unit, SubUnit, UnitType, TribeFullName",
        returnDistinctValues: true,
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return (items)
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getRegionUnitWithTribe: function(tribe){
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const checkedTribe = (tribe && tribe.includes("'")) ? tribe.replaceAll("'", "''") : tribe;
      const queryObject = new Query({
        where: `(TribeFullName = '${checkedTribe}')`,
        outFields: "Region, Unit",
        returnDistinctValues: true,
        returnGeometry: false,
      });
      return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.units[config.env].layerId, queryObject).then(results => {
        let items = [];
        if(results && results.features && results.features.length > 0) {
          items = results.features.map((eaItem) => eaItem.attributes);
        } 
        return (items)
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  }
};

export default UserHelperService;